export default __webpack_public_path__ + "static/media/Preview_desktop_unsel.53e684ce.svg";